import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as S from './styles';

interface EstadoVazioProps {
  icone: IconDefinition;
  titulo: string;
  descricao?: string;
  /** Botao ou link com o proximo passo sugerido. */
  acao?: React.ReactNode;
}

/**
 * Estado vazio do padrao de UX: diz o que aconteceu e o que fazer a seguir.
 *
 * Vai com `role="status"` porque a lista vazia e o RESULTADO de uma consulta --
 * quem usa leitor de tela precisa ser avisado de que a busca terminou sem
 * nada, e nao ficar esperando uma tabela que nunca chega.
 */
const EstadoVazio: React.FC<EstadoVazioProps> = ({
  icone,
  titulo,
  descricao,
  acao,
}) => (
  <S.Container role="status">
    <S.Icone>
      <FontAwesomeIcon icon={icone} />
    </S.Icone>
    <S.Titulo>{titulo}</S.Titulo>
    {descricao && <S.Descricao>{descricao}</S.Descricao>}
    {acao && <S.Acao>{acao}</S.Acao>}
  </S.Container>
);

export default EstadoVazio;
